module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close","closeReason":"Reason","closeComment":"Comment"},"et":{"close":"Close","closeReason":"Reason","closeComment":"Comment"},"ru":{"close":"Close","closeReason":"Reason","closeComment":"Comment"}}')
  delete Component.options._Ctor
}
